const shader = `
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535

uniform sampler2D tEquirect;
varying vec3 vWorldDirection;

vec2 equirectUv( in vec3 dir ) {
	// dir is assumed to be unit length
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}

void main() {
    vec3 direction = normalize(vWorldDirection);
    vec2 sampleUV = equirectUv( direction );
    gl_FragColor = texture2D( tEquirect, sampleUV );
}
`;

export default shader;